import authServiceApi from "../../services/auth-service-api";
import UserServiceApi from "../../services/user-service-api";
import appLogger from "../../utils/app-logger";
import { createCookie } from "../../utils/helpers";

const adminLoginProcess = (data) => {
  return authServiceApi.signinAsAdmin(data)
    .then((response) => {
      if (response) {
        const { jwtToken, refreshToken, legacyToken} = response.legalSimpliToken;
        localStorage.setItem("jwtToken", jwtToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("isAdmin", true);
        createCookie("jwtToken", jwtToken, 1);
        createCookie("refreshToken", refreshToken, 1);
        createCookie("userguid", response.userGuid, 1);
        createCookie("legacyTicket",legacyToken, 1);
        appLogger.log("inside adminLoginProcess");
        // call user service to get userguid
        return UserServiceApi.getUserByEmail(encodeURIComponent(data.userEmail), data.tenantGroupId).then(
          (userResponse) => {
            if (userResponse) {
              const { userGuid } = userResponse;
              var validUserGuid = userGuid;
              if (userGuid.includes("-") == false) {
                validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
              }

              return response;
            }
          }
        );
      }
    })
    .catch((error) => console.log("Error"));
};

export { adminLoginProcess };
